import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { mapAuthError, signUp } from '../../lib/partnerAuth';
import { trackEvent, WEB_PARTNER_SIGNUP } from '../../lib/analytics';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';
import { useSEO } from '../../hooks/useSEO';
import styles from './Auth.module.css';
import logo from '../../assets/images/logo.png';
import { PartnerAffiliatePromoStrip } from '../../components/partners/PartnerAffiliatePromoStrip';
import { PartnerHowItWorks } from '../../components/partners/PartnerHowItWorks';

export function PartnerSignup() {
  usePageAnalytics();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useSEO({
    title: 'Partner Signup — LuvLust',
    description:
      'Earn $0.10 per credited app install from your referral links. Join LuvLust Partners for free.',
  });

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signUp(email, password, name);
      void trackEvent(WEB_PARTNER_SIGNUP);
      navigate('/partners/dashboard');
    } catch (err: unknown) {
      setError(mapAuthError(err, 'Signup failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.page}>
      <PartnerAffiliatePromoStrip />
      <div className={styles.pageBody}>
        <div className={styles.pageLayout}>
          <div className={styles.card}>
          <div className={styles.logoRow}>
            <img src={logo} alt="" width={36} height={36} />
            <span className={styles.brand}>LuvLust Partners</span>
          </div>
          <h1 className={styles.title}>Create your partner account</h1>

          {error && <div className={styles.error}>{error}</div>}

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label htmlFor="name">Your Name</label>
              <input id="name" type="text" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Maya Johnson" />
            </div>
            <div className={styles.field}>
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div className={styles.field}>
              <label htmlFor="password">Password</label>
              <input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" />
            </div>
            <button type="submit" className={styles.submit} disabled={loading}>
              {loading ? 'Creating account...' : 'Sign Up'}
            </button>
          </form>

          <p className={styles.switch}>
            Already have an account? <Link to="/partners/login">Sign in</Link>
          </p>
        </div>
          <PartnerHowItWorks />
        </div>
      </div>
    </div>
  );
}
